import { RATE } from "./crashModel";

// Cosmetic camera and SVG only. Outcomes and financial state never enter here.
export default function createCrashMotion(root) {
  const node = id => root.querySelector(`#crash-${id}`);
  const svg = root.querySelector(".flight-chart"), starField = root.querySelector(".star-field");
  let width = 1000, height = 500, seed = 371, lastView = null, lastReduced = false;
  const stars = [];
  for (let i = 0; i < 46; i++) {
    seed = seed * 48271 % 2147483647; const x = seed % 10000 / 100;
    seed = seed * 48271 % 2147483647; const y = seed % 8600 / 100;
    const element = document.createElement("i");
    element.style.cssText = `left:${x}%;top:${y}%;--size:${i % 9 === 0 ? 2 : 1}px;--opacity:${i % 9 === 0 ? .35 : .13}`;
    starField.append(element); stars.push({ element, x: x / 100, y: y / 100, depth: .2 + i % 7 * .1 });
  }
  const measure = () => { const rect = svg.getBoundingClientRect(); width = rect.width || 1000; height = rect.height || 500; };
  const resize = () => { measure(); if (lastView) controller.draw(lastView, lastReduced); };
  measure(); window.addEventListener("resize", resize);
  const point = (t, maxT, maxM) => [80 + t / maxT * 855, 425 - (Math.exp(t * RATE) - 1) / (maxM - 1) * 305];
  const label = value => value >= 1000 ? `${(value / 1000).toFixed(2).replace(/0+$/, "").replace(/\.$/, "")}k×` : `${value.toFixed(value >= 10 ? 0 : 1).replace(/\.0$/, "")}×`;
  const controller = {
    draw(view, reduced = false) {
      lastView = view; lastReduced = reduced;
      const ready = ["ready", "launching"].includes(view.phase), seconds = view.elapsed / 1000;
      const maxT = 10 + seconds * .88, ascent = .84 * -Math.expm1(-seconds / 9);
      const maxM = seconds > 0 ? Math.max(3, 1 + (view.multiplier - 1) / ascent) : 3;
      const travel = seconds * 12 + seconds ** 1.4 * 1.6, wrap = (v, size) => (v % size + size) % size;
      for (const star of stars) {
        if (ready || reduced) { star.element.style.transform = ""; continue; }
        const x = star.x * width, y = star.y * height;
        star.element.style.transform = `translate(${(wrap(x - travel * star.depth * .85, width) - x).toFixed(2)}px, ${(wrap(y + travel * star.depth * .55, height) - y).toFixed(2)}px)`;
      }
      const samples = [];
      if (!ready) for (let i = 0; i <= 60; i++) samples.push(point(seconds * i / 60, maxT, maxM));
      const path = samples.map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(2)} ${p[1].toFixed(2)}`).join("");
      node("flight-path").setAttribute("d", path); node("flight-glow").setAttribute("d", path);
      node("flight-area").setAttribute("d", samples.length ? `${path}L${samples.at(-1)[0].toFixed(2)} 425L80 425Z` : "");
      node("axis-middle").textContent = label(1 + (maxM - 1) / 2); node("axis-top").textContent = label(maxM);
      node("axis-time-middle").textContent = `${(maxT / 2).toFixed(0)}s`; node("axis-time").textContent = `${maxT.toFixed(0)}s`;
      const unit = Math.max(.65, Math.min(.92, width / 1000)), scale = `scale(${(unit * 1000 / width).toFixed(3)} ${(unit * 500 / height).toFixed(3)})`;
      if (ready) node("rocket-anchor").setAttribute("transform", `translate(148 407) ${scale} rotate(52)`);
      else {
        const [x, y] = samples.at(-1), before = point(Math.max(0, seconds - .04), maxT, maxM);
        const angle = Math.atan2((y - before[1]) * height / 500, (x - before[0]) * width / 1000) * 180 / Math.PI + 90;
        node("rocket-anchor").setAttribute("transform", `translate(${x.toFixed(2)} ${y.toFixed(2)}) ${scale} rotate(${Number.isFinite(angle) ? angle.toFixed(2) : 50})`);
        node("burst-position").setAttribute("transform", `translate(${x.toFixed(2)} ${y.toFixed(2)}) ${scale}`);
      }
    },
    dispose() { window.removeEventListener("resize", resize); stars.forEach(s => s.element.remove()); },
  };
  return controller;
}
